import { Suspense, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Route, Routes } from 'react-router-dom';
import { ROLES } from '../components/modals/constants';
import NoModuleAccess from '../layouts/noModuleAccess';
import PageNotAccessible from '../layouts/pageNotAccessible';
import { RootState } from '../redux/reducers';
import { PAGES, ROUTES } from './constants';
import { Payroll, appRoutes } from './route-configs';

const renderRoutePage = (Layout: any, Component: any, props: any) => (
  <Layout>
    <Suspense fallback={true}>
      <Component {...props} />
    </Suspense>
  </Layout>
);

export const AppRoutes = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    if (crossCompanyAccessError) {
      dispatch({ type: 'SET_CROSS_COMPANY_ACCESS_ERROR', payload: false });
    }
    // eslint-disable-next-line
  }, [location.pathname]);
  const {
    commonReducer: {
      rolePermissions: {
        modulePermissions,
        roleName,
        ukgEmployeeNo,
        isCorporateManager,
        isCorporateUser,
      },
      isFetching,
      crossCompanyAccessError,
    },
  } = useSelector((state: RootState) => state);

  return (
    <>
      <Routes>
        {appRoutes.map(([routeName, Layout, Component, Pages]) => {
          if (roleName === ROLES.PAYROLL && routeName === ROUTES.START) {
            Component = Payroll;
            Pages = [PAGES.Payroll];
          }
          // eslint-disable-next-line
          const view =
            Pages === undefined ||
            (modulePermissions &&
              Array.isArray(Pages) &&
              Pages?.some(
                (page: any) =>
                  (modulePermissions as any)[page as keyof typeof PAGES] &&
                  (modulePermissions as any)[page as keyof typeof PAGES].CanRead
              ));
          // Condition to access pages as per user roles
          const hasNoModuleAccess =
            ([ROLES.GENERAL_FOREMAN, ROLES.CREW_LEADER, ROLES.SUPERVISOR].includes(roleName) ||
              isCorporateManager ||
              isCorporateUser) &&
            !ukgEmployeeNo;
          return (
            <Route
              key={routeName as string}
              path={routeName as string}
              element={
                crossCompanyAccessError
                  ? renderRoutePage(Layout, PageNotAccessible, null)
                  : view
                  ? renderRoutePage(Layout, Component, null)
                  : renderRoutePage(
                      Layout,
                      !isFetching
                        ? hasNoModuleAccess
                          ? NoModuleAccess
                          : PageNotAccessible
                        : () => <></>,
                      null
                    )
              }
            />
          );
        })}
      </Routes>
    </>
  );
};
